import React from 'react';
import './Legal.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="page-header">
        <div className="container">
          <h1>利用規約</h1>
        </div>
      </div>
      
      <section className="section">
        <div className="container">
          <div className="legal-content">
            <p>ゴルマチ利用規約（以下「本規約」といいます）は、ゴルフ専用アプリケーション「ゴルマチ」（以下「本アプリ」といいます）について、本アプリの運営者（以下「運営者」といいます）がその利用条件を定めるものです。</p>
            
            <div className="legal-section">
              <h2>第１条（定義）</h2>
              <p>本規約は、ラウンドマッチングサービスの利用有無にかかわらず、本アプリを利用する全ての会員に適用となります。</p>
              <p>本規約における用語の定義は、以下のとおりとします。</p>
              <p>「会員登録希望者」：本アプリを利用しようとする方をいいます。</p>
              <p>「会員」：第３条に基づき会員としての資格（以下「アカウント」といいます）が付与され、本アプリを利用できる方をいいます。</p>
              <p>「プロフィール情報」：会員が本アプリに登録するアカウントネーム、基本情報（性別、年代、居住地、身長、喫煙有無等）、自己紹介情報、アイコン画像等を総称したものをいいます。</p>
              <p>「プロフィール画面」：本アプリにおいてアカウントごとにプロフィール情報等が表示されるページをいいます。</p>
              <p>「ラウンド」：ゴルフにおいて、18ホールの全て（フルラウンド）又は9ホール（ハーフラウンド）を通してプレーを行うことをいいます。</p>
              <p>「ラウンドプレイヤー会員」：会員のうち、共にラウンドを行うことを希望する他の会員（以下「ラウンド希望会員」といいます）からの申込みを受け、当該ラウンド希望者とラウンドを行う会員をいいます。</p>
              <p>「会員メッセージ」：本アプリを通じて行う会員間のメッセージの交換をいいます。</p>
              <p>「プライバシーポリシー」：運営者が本アプリにおける個人情報の取扱い方針について定めたものをいいます。</p>
            </div>

            <div className="legal-section">
              <h2>第２条（本アプリの機能)</h2>
              <p>会員は、本アプリの以下の機能を利用できるものとします。ただしラウンドマッチングサービスを利用する会員は、18歳以上でなければならないものとします。</p>
              <p>ラウンドマッチングサービス機能</p>
              <p>会員メッセージ機能</p>
              <p>会員検索機能</p>
              <p>その他運営者が将来追加する機能</p>
              <p>運営者は、第１項各号の機能の詳細については、本アプリに掲載するものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第３条（会員登録）</h2>
              <p>会員登録希望者は、本規約及びプライバシーポリシーに同意のうえ、本アプリに自己のメールアドレス及びパスワードを登録し、本アプリへの会員登録を行うものとします。会員登録が正常に完了することによって、会員登録希望者は会員となり、アカウントが付与されます。</p>
              <p>本アプリの会員検索機能以外の機能を利用する会員は、本アプリ上で運営者の指定する本人確認書類画像を添付のうえ、年齢確認申請を行い、運営者から当該申請の承認を受けるものとします。</p>
              <p>本アプリのラウンドマッチングサービス機能を利用する会員は、指定決済システムへの登録を完了しなければならないものとします。</p>
              <p>会員は、プロフィール画面に表示するために、プロフィール情報を登録できるものとします。</p>
              <p>運営者は、会員登録希望者が以下に該当すると判断した場合、アカウントを付与せず、又は既に付与済のアカウントを取消しすることがあります。この場合、運営者は、当該理由を開示する義務を負いません。</p>
              <p>指定決済システムへの登録が承認されず、又は決済が不能となった場合</p>
              <p>本規約に違反した事実がある場合</p>
              <p>申請内容に虚偽が認められた場合</p>
              <p>プライバシーポリシーに同意しない場合</p>
              <p>民法に規定する制限行為能力者に該当し、法定代理人の同意等を得ていない場合</p>
              <p>本規約に定める反社会的勢力に該当するおそれがあると運営者が判断した場合</p>
              <p>会員としての適性を欠くと運営者が判断した場合</p>
              <p>会員は、アカウントを適切に管理するものとし、会員以外の第三者に貸与、譲渡、名義変更、担保設定等の処分をしてはなりません。会員の故意又は過失によるアカウントの第三者利用の結果として生じた損害については、全て会員の責任であるものとし、運営者は責任を負いません。</p>
              <p>会員は、本アプリ内で手続きすることにより、本アプリから退会することができます。ただし、退会の手続きをした時点で、会員が運営者及び他の会員に対して負っている債務が残存する場合は、直ちに当該債務の履行を完了するものとし、当該完了までは退会手続きは終了しないものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第４条（変更手続き)</h2>
              <p>会員は、本アプリに登録した情報（変更不可のものを除く）に変更がある場合、遅滞なく、本アプリ上で変更手続きをしなければならないものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第5条（ラウンドマッチング）</h2>
              <p>ラウンド希望会員は、ラウンドプレイヤー会員のプロフィール情報を確認のうえ、当該ラウンドプレイヤー会員に対し、本アプリを通じて、ラウンドマッチングの申込みを行うものとします。</p>
              <p>前項の申し込みを受け、両当事者において、会員メッセージによって対象ラウンドコースまでの送迎の有無や対象ラウンド日の昼食代の負担等を含めた必要事項を調整のうえ、ラウンドプレイヤー会員が承諾した場合、両当事者間にラウンドマッチングが成立し、ラウンド希望会員のラウンドコインが費消されるものとします。ただし、ラウンド希望会員の保有するラウンドコインの残高がラウンドプレイヤー会員の設定したラウンドポイントを下回る場合は、ラウンドマッチングは不成立となります。</p>
              <p>両当事者は、ラウンドマッチングをキャンセルする場合、本アプリにおいて、対象ラウンド日の前日における運営者所定時刻（以下「キャンセル期限」といいます）までにキャンセル手続きを行うものとします。</p>
              <p>ラウンド希望会員は、対象ラウンドに要するゴルフ場料金について、自らの利用分はもとより、ラウンドプレイヤー会員分についても負担する義務を負うものとし、当該義務については、申込時の調整においても覆せないものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第6条（禁止事項)</h2>
              <p>会員は、本アプリの利用時及び対象ラウンドにおいて、以下の行為をしてはならないものとします。</p>
              <p>相手方の事前の承諾なく相手方の写真や動画を撮影し、又は録音をする行為</p>
              <p>相手方に対する性的な言動、ストーキング、嫌がらせ、ハラスメント、マウンティング又はこれらに類する行為</p>
              <p>相手方が不要と感じる指導やアドバイス等を継続又は繰り返す行為</p>
              <p>相手方に対する誹謗中傷、脅迫、暴力的と判断されるような行為</p>
              <p>相手方の個人情報を無断で収集、蓄積する行為</p>
              <p>会員を誤認させる表現をする行為</p>
              <p>第三者になりすます行為</p>
              <p>運営者、他の会員、第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為</p>
              <p>虚偽又は事実と異なる情報を本アプリに登録する行為、登録情報を不正に改ざんする行為</p>
              <p>運営者のシステム、サーバー、ネットワークに負担をかけ、妨害し、又は障害等を発生させる行為</p>
              <p>営業、宣伝、広告、勧誘、その他営利を目的とする行為、マルチ商法等に関する行為</p>
              <p>宗教、政治等に関する行為</p>
              <p>法令又は公序良俗に反する行為</p>
              <p>その他運営者が不適切と判断する行為</p>
              <p>運営者は、会員が前項に違反する行為を認めた場合は、当該違反会員について、第11条第２項の措置を行うほか、警察、所轄官庁その他の機関に通報する場合があるものとします。</p>
              <p>前項の結果について、当該会員は、異議を述べないものとし、運営者は、当該会員に対し、いかなる損害賠償責任も負わず、いかなる補償も行わないものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第7条（本アプリの停止等)</h2>
              <p>運営者は、以下の各号いずれかに該当する場合、予告なく、本アプリの全部又は一部の提供を停止することができるものとします。</p>
              <p>緊急でコンピュータシステムの点検、保守を行う場合</p>
              <p>停電、サーバー故障等が発生した場合</p>
              <p>コンピュータ、通信回線等に不良がある場合</p>
              <p>地震、落雷、火災等の不可抗力による場合</p>
              <p>その他運営者が必要と判断した場合</p>
              <p>運営者は、会員が本規約の一つにでも違反するおそれを認めた場合、予告なく当該会員に対する本アプリの提供を停止すると共に、以下の対処を行うことができるものとします。</p>
              <p>アカウントを抹消すること</p>
              <p>投稿コンテンツを削除又は非公開の状態にすること</p>
              <p>運営者は、第１項及び第２項によって会員に生じた損害について、一切の責任を負わないものとします。また、運営者は前項によって運営者に生じた損害について、会員及び会員であった者に対して請求することができるものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第8条（権利の帰属)</h2>
              <p>本アプリに関する著作権、商標権、その他一切の権利については、本アプリに掲示される以前から会員又は第三者に帰属していたものを除き、全て運営者又は運営者に許諾した権利者に帰属するものとします。</p>
              <p>会員は、前項に基づき、本アプリにおける運営者に帰属する権利を含む情報について、運営者に無断で使用、転用、転載、複製等を行ってはならないものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第9条（反社会的勢力排除）</h2>
              <p>会員又は会員登録希望者は、自らが暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋等社会運動標榜ゴロ又は特殊知能暴力団、その他これらに準ずる者(以下これらを「反社会的勢力」といいます）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。</p>
              <p>反社会的勢力が経営を支配していると認められる関係を有すること</p>
              <p>反社会的勢力が経営に実質的に関与していると認められる関係を有すること</p>
              <p>自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること</p>
              <p>反社会的勢力に資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること</p>
              <p>役員又は経営に実質的に関与している者が反社会的勢力と社会的に非難されるべき関係を有すること</p>
              <p>会員又は会員登録希望者は、自ら又は第三者を利用して次の各号の一つにでも該当する行為を行わないことを確約します。</p>
              <p>暴力的な要求行為</p>
              <p>法的な責任を超えた不当な要求行為</p>
              <p>取引に関して、脅迫的な言辞又は暴力を用いる行為</p>
              <p>風説を流布し、偽計若しくは威力を用いて相手方の信用を毀損し、又は業務を妨害する行為</p>
            </div>

            <div className="legal-section">
              <h2>第10条（秘密の保持）</h2>
              <p>会員は、本アプリにて知り得た運営者の営業秘密、会員の個人情報、スキル、技術等、スコアの情報について、第三者に漏洩又は開示（ＳＮＳ等における公表を含みます）してはなりません。</p>
            </div>

            <div className="legal-section">
              <h2>第11条（免責事項）</h2>
              <p>本アプリは、運営者が、会員間のニーズの実現を支援する場としてのプラットフォームを提供するサービスとなります。このため、会員間のラウンドの提供に関しては、すべて会員が自らの責任で行うものであり、運営者は当事者とはならず、代理人、仲介人等にもなりません。このため、運営者は、ラウンドにおけるトラブル等については、本規約に定める運営者の措置を除き、一切関与せず、責任を負わないものとします。</p>
              <p>運営者は、運営者が一般的なサービス業者として措置する程度のセキュリティ策を実施している場合において、なお回避が困難なウィルスやマルウェア等によって利用者に損害が生じたとしても、いかなる責任も負わないものとします。</p>
              <p>運営者は、会員の機器又は通信回線等の障害、エラー、バグの発生等について一切責任を負わず、かかる状況等により会員又は第三者に生じた損害について、一切責任を負わないものとします。</p>
              <p>運営者は、会員がURL等を書き込んだ結果、他の会員が当該URLのリンク先で被った損害について、いかなる責任も負わないものとします。</p>
              <p>本規約に定めた運営者を免責する規定は、運営者に故意又は重過失が存する場合には適用しません。また、本規約のいずれかの条項の一部が民法、消費者契約法その他の法令により無効、取消、又は差し止めとなった場合であっても、残部は継続して完全に効力を有するものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第12条（本アプリ、本規約の変更）</h2>
              <p>運営者は、いつでも本アプリの内容を変更できるものとします。かかる変更を行った際は、本アプリを通じて公表するものとし、公表後に会員が本アプリを利用した場合は、変更に同意したものとみなします。</p>
              <p>運営者は、本規約の内容について、必要に応じて変更することができます。この場合、民法第548条の４に従うものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第13条（個人情報の取扱い）</h2>
              <p>運営者は、会員の個人情報について、本規約及びプライバシーポリシーに従って取り扱うものとします。</p>
            </div>

            <div className="legal-section">
              <h2>第14条（準拠法及び管轄合意)</h2>
              <p>本規約は、日本法に基づき解釈されるものとします。会員と運営者の間で生じた一切の紛争については、訴額に応じて、運営者の住所地を管轄する地方裁判所又は簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
              <div className="text-right mt-4">
                <p>以上</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;